import { computed } from 'vue';
import { trimTextField } from '@/utils';
import { validationLimitingValue } from '@/constants';
import { PASSWORD_PATTERN } from '@/utils/regularExpression';
import { i18n } from '@/locales';
import { isRequired, greaterThanMinLength, isValidPattern, } from './index';
const { PASSWORD_MIN_BYTE, } = validationLimitingValue;
const createUserFormRules = (formRuleLc) => ({
    userId: computed({
        get() {
            return [
                (v) => isRequired(trimTextField(v))
                    || i18n.t(`${formRuleLc}value_require`),
            ];
        },
        set() { },
    }),
    adminPhoneNumber: computed({
        get() {
            return [
                (v) => isRequired(trimTextField(v))
                    || i18n.t(`${formRuleLc}value_require`),
            ];
        },
        set() { },
    }),
    hubName: computed({
        get() {
            return [
                (v) => isRequired(v)
                    || i18n.t(`${formRuleLc}value_require`),
            ];
        },
        set() { },
    }),
    level: computed({
        get() {
            return [
                (v) => isRequired(v)
                    || i18n.t(`${formRuleLc}value_require`),
            ];
        },
        set() { },
    }),
    password: computed({
        get() {
            return [
                (v) => isRequired(v)
                    || i18n.t(`${formRuleLc}value_require`),
                (v) => greaterThanMinLength(v.length, PASSWORD_MIN_BYTE)
                    || i18n.t(`${formRuleLc}wrong_value`, {
                        length: PASSWORD_MIN_BYTE,
                    }),
                (v) => isValidPattern(PASSWORD_PATTERN, v) || i18n.t(`${formRuleLc}wrong_value`),
            ];
        },
        set() { },
    }),
});
export default createUserFormRules;
